import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import colors from '../../../styles/colors'

const ToggleBtn = ({ yn, setYn, id, className, toggleText, width }) => {
  const handleSwitchChange = () => {
    const updatedValue = yn === 'Y' ? 'N' : 'Y'
    setYn(updatedValue)
  }
  let buttonText = ''
  if (toggleText === 'onOff' && yn === 'Y') {
    buttonText = 'ON'
  } else if (toggleText === 'onOff' && yn === 'N') {
    buttonText = 'OFF'
  } else if (toggleText === '24hr') {
    buttonText = '24 시간'
  } else {
    buttonText = yn === 'Y' ? '판매중' : '숨김'
  }

  return (
    <ToggleWrap className={className} width={width}>
      <input
        type="checkbox"
        className="toggle"
        id={id}
        hidden
        checked={yn === 'Y'}
        onChange={handleSwitchChange}
      />
      <label htmlFor={id} className="toggleSwitch d-flex align-items-center">
        <span className="toggleButton"></span>
        <span className="toggleText">{buttonText}</span>
      </label>
    </ToggleWrap>
  )
}

export default ToggleBtn

const ToggleWrap = styled.div`
  .toggleSwitch {
    width: ${(props) => (props.width ? props.width + 'px' : '63px')};
    height: 28px;
    display: block;
    position: relative;
    background-color: #a8a8a8;
    border-radius: 30px;
    cursor: pointer;
    font-size: 14px;
  }
  .toggleSwitch .toggleButton {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translateY(-50%);
    border-radius: 50%;
    background: #ffff;
  }

  .toggle:checked ~ .toggleSwitch {
    background: ${colors.mainG};
  }

  .toggle:checked ~ .toggleSwitch .toggleButton {
    left: calc(100% - 25px);
    background: ${colors.W1};
  }

  .toggleSwitch,
  .toggleButton {
    transition: all 0.3s ease-in;
  }

  .toggleText {
    color: ${colors.W1};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all 0.3s ease-in;
    opacity: 0;
  }

  .toggle:checked ~ .toggleSwitch .toggleText {
    left: 11px; /* 'on'일 때는 왼쪽으로 이동 */
    opacity: 1;
  }

  .toggle:not(:checked) ~ .toggleSwitch .toggleText {
    right: 10px; /* 'off'일 때는 오른쪽으로 이동 */
    opacity: 1;
  }
`
